import FormEmailHook from 'root/main/components/forms/ui/formEmailHook';
import { gtm } from 'root/utils/tracking/googleTagManagerDeprecated';
import Events from 'root/helpers/events';
import { LoggingHandler } from 'root/utils/errorReporting/LoggingHandler';
import FormControllerInit from 'root/main/components/forms/formControllerInit';
import { GoogleTagManager } from 'root/utils/tracking/GA4/googleTagManager';
import {
    FormGTMObjectConstructor,
    getPlacement,
} from 'root/utils/tracking/GA4/formTracking';
import afterIntercomHasLoaded from 'root/utils/afterIntercomHasLoaded';
import { getHashFromURL } from 'root/utils/url/urlUtils';
import { hideWaitingSpinner, showWaitingSpinner } from './lightbox/waitForVWOCookie';

/* it is important for these default vars initialization to be outside of the default function so that they don't get set and the form lightbox will lose its current state */
let formsEmailHook = {};
let wrapper = null;
let targetFile = null;
let lsForm = null;
let formGTMObjectConstructor = null;

export default function FormEmailHookCtl() {
    const body = document.body;
    const importUIToEmailHookForm = formEl => {
        import(/*webpackChunkName: "[request]"*/ 'root/main/components/forms/ui/formUI')
            .then(module => {
                const ui = new module.default(formEl);
                return ui.loadFormSpecs();
            })
            .then(() => {
                const dropdowns = formEl.querySelectorAll('select.gb-form__field-text');
                dropdowns.forEach(dropdown => {
                    if (dropdown.parentElement.classList.contains('js-field-valid')) {
                        dropdown.parentElement.classList.remove('js-field-valid');
                    }
                });
            });
    };

    const importTooltipsFile = formEl => {
        import(
            /*webpackChunkName: "[request]"*/ 'root/main/components/tooltip/tooltip'
        ).then(module => {
            const tooltips = formEl.querySelectorAll('[data-tooltip]');
            module.default(tooltips);
        });
    };

    const formEmailHookCallback = event => {
        lsForm = formsEmailHook[targetFile].element?.querySelector(
            '[data-form*="ls-form"]'
        );
        const emailHookFormLoaded = new CustomEvent('emailHookFormLoaded');
        if (lsForm) {
            /* this custom event is used in the email only for triggering actions when the lightbox has been initialized */
            Events.fire('emailHookOpened');
            document.body.dispatchEvent(emailHookFormLoaded);

            /* We are dynamically importing this here because once a new form is created inside the lightbox, it will not
            have access to formController if it has not been initialized previously on the page may be due to the absence
            of a submit button. By this we are ensuring no matter what that the formController will be initialized inside the lightbox. */

            FormControllerInit(lsForm);

            import(
                /*webpackChunkName: "agnosticFormController"*/ 'root/main/components/forms/agnosticFormControllerInit'
            ).then(module => module.default(lsForm));

            lsForm.dataset.formPlacement =
                event && event.target ? getPlacement(event.target) : getPlacement(lsForm);

            importUIToEmailHookForm(lsForm);
            importTooltipsFile(lsForm);

            formGTMObjectConstructor = new FormGTMObjectConstructor(lsForm);
            gtm.form(lsForm).sendEvent('email-hook-open');
            GoogleTagManager.sendEvent(
                formGTMObjectConstructor.getFormGTMObject('form_email_hook_open')
            );
        } else {
            LoggingHandler().logError(
                `leadform: form element is undefined on uri: ${window.location.pathname.substring(
                    1
                )}`,
                {
                    searchTerm: 'email-hook-forms-error',
                    tags: ['forms'],
                    fileName: 'formEmailHookCtl.js',
                }
            );
        }
        show(targetFile);
    };

    const clickHandler = e => {
        setEmailHookWrapper();
        const formEmailHookController = new FormEmailHook(targetFile, wrapper);
        formEmailHookController.load(formEmailHookCallback, e);
        formsEmailHook[targetFile] = formEmailHookController;
    };

    const setEmailHookWrapper = () => {
        const existingLightboxWrapper = document.querySelector('.js-lightbox-wrapper');
        if (existingLightboxWrapper) existingLightboxWrapper.remove();
        const n = document.createElement('div');
        n.classList.add('js-lightbox-wrapper');
        buildEmailHookLayoutHTML(n);
    };

    const buildEmailHookLayoutHTML = n => {
        // build wrapper for the bg button & the modal
        const overlayWrapper = body.insertBefore(n, body.firstChild);

        // build the modal content wrapper & add to the parent wrapper
        const modalContentWrapper = document.createElement('div');
        wrapper = overlayWrapper.insertBefore(
            modalContentWrapper,
            overlayWrapper.firstChild
        );

        // set transitions on siteContent wrapper
        const siteContent = document.querySelector('#page');
        if (siteContent) {
            siteContent.classList.add('tw:transition-[filter]', 'tw:duration-150');
            siteContent.classList.add('tw:blur-[5px]', 'tw:overflow-hidden');
            siteContent.setAttribute('inert', '');
        }
        buildBackgroundOverlayButton(overlayWrapper);
        showWaitingSpinner();
    };

    const buildBackgroundOverlayButton = overlayWrapper => {
        const overlayCloseButton = document.createElement('button');
        overlayCloseButton.setAttribute('type', 'button');
        overlayCloseButton.setAttribute('tabindex', '-1');
        overlayCloseButton.setAttribute('aria-label', 'Close pop-up');
        overlayCloseButton.classList.add(
            'tw:border-transparent',
            'tw:border-0',
            'tw:border-none',
            'tw:fixed',
            'tw:z-10',
            'js-leadform-email-hook__background-overlay-button'
        );
        overlayWrapper.insertBefore(overlayCloseButton, overlayWrapper.firstChild);
        overlayCloseButton.addEventListener('click', hide);
    };

    const addModalCloseButton = () => {
        const closeBtn = document.createElement('button');
        closeBtn.classList.add('js-leadform-email-hook__modal__close-btn');
        closeBtn.innerHTML = `
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect width="24" height="24" fill="white"/>
                <path d="M10.6122 11.9999L6.3999 7.78758L7.78757 6.3999L11.9999 10.6122L16.2122 6.3999L17.5999 7.78758L13.3876 11.9999L17.5999 16.2122L16.2122 17.5999L11.9999 13.3876L7.7876 17.5999L6.39993 16.2122L10.6122 11.9999Z" fill="#191513"/>
            </svg>
        `;
        closeBtn.setAttribute('type', 'button');
        closeBtn.setAttribute('aria-label', 'Close pop-up');
        wrapper.insertBefore(closeBtn, wrapper.firstElementChild);
        closeBtn.addEventListener('click', hide);
    };

    const show = () => {
        hideWaitingSpinner(false);
        body.classList.add('js-show-lightbox', 'js-show-email-hook');
        formsEmailHook[targetFile].show();
        if (wrapper) {
            wrapper.parentElement.style.display = 'flex';
            wrapper.style.display = 'flex';
        }
        afterIntercomHasLoaded(toggleIntercomDisplay);
        addModalCloseButton();
    };

    const hide = () => {
        body.classList.remove('js-show-lightbox', 'js-show-email-hook');
        const siteContent = document.querySelector('#page');
        if (siteContent) {
            siteContent.classList.remove('tw:blur-[5px]', 'tw:overflow-hidden');
            siteContent.classList.remove('tw:transition-[filter]', 'tw:duration-150');
            siteContent.removeAttribute('inert');
        }
        if (wrapper) {
            wrapper.parentElement.style.display = 'none';
            wrapper.style.display = 'none';
        }
        for (let key in formsEmailHook) {
            if (!Object.prototype.hasOwnProperty.call(formsEmailHook, key)) continue;
            formsEmailHook[key].hide();
        }
        gtm.form(lsForm).sendEvent('email-hook-closed');
        if (formGTMObjectConstructor) {
            GoogleTagManager.sendEvent(
                formGTMObjectConstructor.getFormGTMObject('form_email_hook_closed')
            );
        }
        afterIntercomHasLoaded(() => toggleIntercomDisplay(false));

        document.removeEventListener('keydown', escapeHandler);
    };

    const toggleIntercomDisplay = (hide = true) => {
        const intercom = document.querySelector(
            '.intercom-lightweight-app, .intercom-app, #intercom-container'
        );
        const toggle = hide ? 'none' : 'block';
        intercom && (intercom.style.display = toggle);
    };

    const getFormNameFromUrl = url => {
        return getHashFromURL(url).split('|')[1];
    };

    const escapeHandler = e => {
        if (e.key === 'Escape') {
            const activeTooltips = document.querySelectorAll('.js-show-tooltip-dialog');
            console.log(activeTooltips);
            if (activeTooltips.length === 0) {
                hide();
            }
        }
    };

    const init = (e, url) => {
        targetFile = getFormNameFromUrl(url);
        clickHandler(e);
        document.addEventListener('keydown', escapeHandler);
    };

    return {
        init,
    };
}
